/** Builds one CSV document from columns and rows. Every cell is quoted
 *  (matching FloatingAttributeTable's own exportCsv), which is always valid
 *  CSV and sidesteps having to detect which values need it. */
export function toCsv(columns: string[], rows: Record<string, unknown>[]): string {
  const cell = (value: unknown) =>
    `"${String(typeof value === 'object' && value !== null ? JSON.stringify(value) : (value ?? '')).replace(/"/g, '""')}"`;

  return [
    columns.map(cell).join(','),
    ...rows.map((row) => columns.map((column) => cell(row[column])).join(',')),
  ].join('\n');
}

/** Triggers a browser download of a CSV string — the same Blob + anchor-click
 *  pattern FloatingAttributeTable's own export already used, factored out so
 *  a second caller does not have to repeat it. */
export function downloadCsv(filename: string, csv: string): void {
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
